import types from 'constants/actionTypes';

export const resetCheckLockStatus = () => ({
  type: types.RESET_CHECK_LOCK_STATUS,
});
